export const getAllImageSizeByFormat = (
  object: Record<string, { formats: Record<string, string> }>,
  format: string,
) => {
  const outputObject: Record<string, string> = {}
  for (const item in object) {
    outputObject[item] = object[item].formats[`image/${format}`]
  }
  return outputObject
}

export const removeValueFromObject = (object: Record<string, unknown>, value: string) => {
  const outputObject = object
  for (const key in object) {
    if (outputObject[key] === value) {
      delete outputObject[key]
    }
  }
  return outputObject
}
